export default "__VITE_ASSET__CkU2lVlU__"